import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid var(--Grey3);

  button {
    margin: 0;
    width: 55.49px;
    height: 32px;
    left: 837px;
    top: 48px;
    background: #212529;
    border-radius: 4px;
    font-size: 12px;
  }
`;
